module.exports = __webpack_public_path__ + "static/media/laptop-frame-v2.b35996fb.png";